import React, { useState, useEffect, useRef, useContext } from "react";
import { PopupContext } from "../PopupContext.js";
import SidebarComercial from "./sidebarComercial/sidebarComercial.js";

function DashboardAdminComercial({ userId }) {

  const { openParentPack, openPackParent, popupRef, closeAllPopups } = useContext(PopupContext);
  const logosContainerRef = useRef(null);




// Handle logo clicks to open the appropriate popup
  const handleLogoClick = (packName) => {
    console.log(`Clicked on ${packName}`);
    closeAllPopups(); // Ferme tous les autres popups avant d'ouvrir un nouveau
    openPackParent(packName); // Met à jour openParentPack via le contexte
  };

  // Handle scroll behavior for logos container
  useEffect(() => {
    const checkScroll = () => {
      const container = logosContainerRef.current;
      if (!container) return;

      const containerHeight = container.scrollHeight;
      const viewportHeight = window.innerHeight - 100; // Adjusted for margins and padding

      if (containerHeight > viewportHeight) {
        container.classList.add("scroll-enabled");
      } else {
        container.classList.remove("scroll-enabled");
      }
    };

    checkScroll();
    window.addEventListener("resize", checkScroll);

    return () => window.removeEventListener("resize", checkScroll);
  }, []);

  return (
    <div className="dashboardClient">
      <SidebarComercial />
      <div className="dashboard-backgroundClient">
        <div className="overlayClient">
          <div className="logos-containerClient" ref={logosContainerRef}>
            <div
              className="logo-item-dashboardClient"
            
            >
              <img
                src="/images/services/1.png"
                alt="Logo 1"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Unlimited Bonus</span>
            </div>

            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/2.png"
                alt="Logo 2"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/3.jpg"
                alt="Logo 3"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/4.png"
                alt="Logo 4"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/5.png"
                alt="Logo 5"
                className="logo-dashboardClient"
              />
            </div>

            <div
              className="logo-item-dashboardClient"
            
            >
              <img
                src="/images/services/6.png"
                alt="Logo 6"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Repair Service</span>
            </div>

            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/7.png"
                alt="Logo 7"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/8.png"
                alt="Logo 8"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/9.png"
                alt="Logo 9"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/10.png"
                alt="Logo 10"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/11.png"
                alt="Logo 11"
                className="logo-dashboardClient"
              />
            </div>
            <div
              className="logo-item-dashboardClient"
             
            >
              <img
                src="/images/services/12.png"
                alt="Logo 12"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Wallets</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/13.png"
                alt="Logo 13"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/14.png"
                alt="Logo 14"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/15.png"
                alt="Logo 15"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/16.png"
                alt="Logo 16"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/17.png"
                alt="Logo 17"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/18.png"
                alt="Logo 18"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/19.png"
                alt="Logo 19"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/20.png"
                alt="Logo 20"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/21.png"
                alt="Logo 21"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/painting.png"
                alt="Logo 22"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/23.png"
                alt="Logo 23"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/24.png"
                alt="Logo 24"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/25.png"
                alt="Logo 25"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/26.png"
                alt="Logo 26"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/27.png"
                alt="Logo 27"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/28.png"
                alt="Logo 28"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/29.png"
                alt="Logo 29"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/30.png"
                alt="Logo 30"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/31.png"
                alt="Logo 31"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <a
                href="https://t.me/Smwgtd"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/images/services/32.png"
                  alt="Logo 32"
                  className="logo-dashboardClient"
                />
              </a>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/33.png"
                alt="Logo 33"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/34.png"
                alt="Logo 34"
                className="logo-dashboardClient"
              />
            </div>
            <div
              className="logo-item-dashboardClient"
             
            >
              <img
                src="/images/services/35.png"
                alt="Logo 35"
                className="logo-dashboardClient"
              />
            </div>
            <div
              className="logo-item-dashboardClient"
            
            >
              <img
                src="/images/services/packAJKQ.jpeg"
                alt="Logo 36"
                className="logo-dashboardClient"
              />
            </div>
            <div
              className="logo-item-dashboardClient"
             
            >
              <img
                src="/images/services/36.png"
                alt="Logo 37"
                className="logo-dashboardClient"
              />
            </div>
            <div
              className="logo-item-dashboardClient"
            
            >
              <img
                src="/images/services/37.png"
                alt="Logo 38"
                className="logo-dashboardClient"
              />
            </div>
            <div
              className="logo-item-dashboardClient"
            
            >
              <img
                src="/images/services/packRRRR.jpeg"
                alt="Logo 39"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/packRS.jpeg"
                alt="Logo 40"
                className="logo-dashboardClient"
              />
            </div>
            <div
              className="logo-item-dashboardClient"
           
            >
              <img
                src="/images/services/packTD.jpeg"
                alt="Logo 41"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/39.png"
                alt="Logo 42"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/40.png"
                alt="Logo 43"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/facilityVIP.png"
                alt="Logo 44"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/cach_back.png"
                alt="Logo 45"
                className="logo-dashboardClient"
              />
            </div>

        
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardAdminComercial;